export class TransactionManager {
    constructor() {
        this.transactions = [];
    }

    loadTransactions(address = null) {
        const allTx = JSON.parse(localStorage.getItem('activationTransactions') || '[]');
        if (address) {
            return allTx.filter(tx => tx.address === address);
        }
        return allTx;
    }

    getLatestTransaction(address) {
        const userTx = this.loadTransactions(address);
        return userTx.length > 0 ? userTx[userTx.length - 1] : null;
    }

    getAllTransactions() {
        return this.loadTransactions();
    }

    clearTransactions() {
        localStorage.removeItem('activationTransactions');
        this.transactions = [];
        console.log('🗑️ Локальні транзакції очищені');
    }

    exportTransactions() {
        const transactions = this.loadTransactions();
        const dataStr = JSON.stringify(transactions, null, 2);
        const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
        
        const exportFileDefaultName = `bitcoin-activations-${Date.now()}.json`;
        
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', dataUri);
        linkElement.setAttribute('download', exportFileDefaultName);
        linkElement.click();
    }
}
